export default __webpack_public_path__ + "static/media/caret-right-solid-red.b934edd9.svg";